<div class="displayLibsCenter" fxFlex="33"
     fxLayout="column" fxLayoutAlign="center center">
  <lib-reset-password-required
    [apiEndpoint]="endPoint"
    [successLink]="'login'"
    [logoImage]="'../../../../assets/logos/saCentre.png'"
    [header]="'Reset Password'"
    [subHeading]="'Please check your email for your temporary password.'"
    [cardWidth]="'500px'">
  </lib-reset-password-required>

</div>
